import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { NotFoundComponent } from './not-found/not-found.component';
import { AproposModule } from './apropos/apropos.module';
import { GestionSujetsModule  } from './gestion-sujets/gestion-sujets.module';
import { GestionStagiairesModule  } from './gestion-stagiaires/gestion-stagiaires.module';
import { GestionEntreprisesModule  } from './gestion-entreprises/gestion-entreprises.module';

const appRoutes: Routes = [
  { 
    path: '', 
    loadChildren: () => AproposModule
  },
  {
    path: 'gestion_stagiaires',
    loadChildren: () => GestionStagiairesModule
  },
  {
    path: 'gestion_entreprises',
    loadChildren: () => GestionEntreprisesModule
  },
  {
    path: 'gestion_sujets',
    loadChildren: () => GestionSujetsModule
  },
  { 
    path: '**', 
    component: NotFoundComponent 
  }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules});





// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/app-routing.module.ts